/**
 * Authentication & session FeatureModule.
 *
 * Surfaces (all under the authenticated AppShell):
 *   • /compte               — profile/self view: identity, effective capabilities, active-session
 *                             panel (token refresh + session-kill), and the in-app unauthenticated
 *                             shell (re-auth) when the session ends in-tab.
 *   • /compte/utilisateurs  — capability-gated user management (cap: iam.utilisateur.manage),
 *                             consuming the real GET /utilisateurs (501 stub today, renders empty).
 *
 * The route-level /login page and the topbar logout are owned by the app scaffold; this module owns
 * the authenticated-area account/session surface and the reusable login/reset/re-auth components.
 *
 * Module requiredCapabilities is empty: every authenticated user may view their own account (like
 * the dashboard). The users nav entry carries its own tighter capability so only managers see it.
 */
import type { FeatureModule } from "@/app";
import { SessionPage } from "./SessionPage";
import { UsersPage } from "./UsersPage";
import { registerAuthMessages, AUTH_CAPS } from "./messages";

const SECTION = "nav.auth.section";

const authModule: FeatureModule = {
  id: "auth",
  title: "Compte",
  requiredCapabilities: [],
  routes: [
    { path: "/compte", element: <SessionPage /> },
    { path: "/compte/utilisateurs", element: <UsersPage /> },
  ],
  nav: [
    {
      id: "session",
      path: "/compte",
      label: "nav.auth.session",
      icon: "◉",
      order: 90,
      section: SECTION,
    },
    {
      id: "users",
      path: "/compte/utilisateurs",
      label: "nav.auth.users",
      icon: "◫",
      order: 91,
      section: SECTION,
      requiredCapabilities: [AUTH_CAPS.usersManage],
    },
  ],
  onRegister() {
    registerAuthMessages();
  },
};

export default authModule;
